module.exports = __webpack_public_path__ + "static/GridShow-06473402b404066082a664d12b941c53.png";